//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* jshint jquery: true */
/* global angular: false */

import $ from "jquery";

import _ from "js/underscore-mixins";

(function() {
    /**
     * This directive is used to dynamically bind and unbind watchers within a comment.
     * Usage:
     *  <div class="container" comment-suspendable>
     *      <div class="comment-container" ng-repeat="item in items"></div>
     *  </div>
     *  In the example above, all scopes generated inside of '.comment-container' will have their watchers removed if the
     *  is element is scrolled/resized out of view.
     *  NOTE: Since this directive applies to the scope of the '.comment-container', any nested directives with isolate scope
     *  will NOT be detached on scroll/resize.
     */
  angular.module('curalate').directive('commentSuspendable', () => {
    const TIME_BETWEEN_UPDATES = 2500; // The number of milliseconds between updates - we'll need to tweak this.
    const TIME_BETWEEN_UPDATES_SHORT = 500;
        // When true, comments that have their watches suspended will be outlined in red while ones with active watchers will be outlined in green
        // Ones with active watchers will also have '.watching', so you can query the number of active ones
        // e.g. $('[comment-suspendable]')[0].querySelectorAll('.watching').length
    const DEBUG = false;

    return {
      link(scope, element) {
        const $window = $(window);
        let watchersForId = {};
        const uniqueSuspendableId = Math.random().toString(32).slice(2);
        const trackedEvents = [`scroll.suspendable-${uniqueSuspendableId}`, `resize.suspendable-${uniqueSuspendableId}`];
        let heartbeat;
        let isSuspended = false;

        const suspend = function(suspendId, scopeToSuspend, elem) {
          if (!watchersForId[suspendId] && scopeToSuspend) {
            if (DEBUG) {
              elem.css({
                outline: '1px solid red',
              });
              elem.removeClass('watching');
            }
            watchersForId[suspendId] = scopeToSuspend.$$watchers;
            scopeToSuspend.$$watchers = [];
          }
        };

        const resume = function(resumeId, scopeToResume, elem) {
          if (watchersForId[resumeId] && scopeToResume) {
            if (DEBUG) {
              elem.css({
                outline: '1px solid green',
              });
              elem.addClass('watching');
            }
            scopeToResume.$$watchers = watchersForId[resumeId];
            delete watchersForId[resumeId];
          }
        };

                // If the scope gets destroyed, unbind the listeners we created
        scope.$on('$destroy', () => {
          $window.off(trackedEvents.join(' '));
          element.off('suspend resume');
          clearInterval(heartbeat);
          watchersForId = null;
        });

        const getCommentsAndThreads = function() {
          return _(element.find('.comment-container, .thread-container')).map((container) => {
            const elem = angular.element(container);
            return {
              scope: elem.scope(),
              elem,
            };
          });
        };

        const isContainerVisible = function($element) {
          const rect = $element[0].getBoundingClientRect();

          return rect.bottom >= 0 && rect.bottom - $window.height() < rect.height;
        };

        const scopeCheckFunc = function() {
          let elemTop = 0;
          let elemHeight = 0;
          const commentsAndThreads = getCommentsAndThreads();

                    // - If the element is not visible, suspend everything
                    // - If the element is out of the window bounds, suspend everything
                    // - Otherwise, enable watchers for elements within element that are visible on browser
          if (!isContainerVisible(element)) {
            if (!isSuspended) {
              _.each(commentsAndThreads, (obj) => {
                if (!obj.elem.attr('data-scope-id')) {
                  obj.elem.attr('data-scope-id', _.uniqueId());
                }

                suspend(obj.elem.attr('data-scope-id'), obj.scope, obj.elem);
              });
            }

            isSuspended = true;

            return;
          } else {
            isSuspended = false;
          }

          const containerHeight = element.height();
          const containerScrollTop = element.scrollTop();

                    // For every scope...
          for (let i = 0; i < commentsAndThreads.length; i++) {
            const obj = commentsAndThreads[i];

            elemHeight = obj.elem.outerHeight();
            elemTop = obj.elem[0].offsetTop;

            if (!obj.elem.attr('data-scope-id')) {
              obj.elem.attr('data-scope-id', _.uniqueId());
            }

            if (elemTop + elemHeight > containerScrollTop && elemTop <= containerScrollTop + containerHeight) {
              resume(obj.elem.attr('data-scope-id'), obj.scope, obj.elem);
            } else {
              suspend(obj.elem.attr('data-scope-id'), obj.scope, obj.elem);
            }
          }
        };

                // element MUST be positioned for our algorithm to work.
        if (element.css('position') === 'static') {
          element.css('position', 'relative');
        }

                // Clean up after long/fast scrolls and reattach if hidden elements become visible
        heartbeat = setInterval(scopeCheckFunc, TIME_BETWEEN_UPDATES);

                // Run the scopeCheckFunc if the user hovers over any comment
        element.hover(() => {
          scopeCheckFunc();
          clearInterval(heartbeat);
          heartbeat = setInterval(scopeCheckFunc, TIME_BETWEEN_UPDATES_SHORT);
        }, () => {
          clearInterval(heartbeat);
          heartbeat = setInterval(scopeCheckFunc, TIME_BETWEEN_UPDATES);
        });
      },
    };
  });
})();
